import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layout/MainLayout';
import { Button } from '../../components/elementsDS/buttons/Buttons';

const PageNotFound = () => (
  <div className="text-center">
    <img src="/img/404vector.svg" alt="pagenotfound" className="img-fluid pb-5" height="600" width="600" />

    <p className="pt-3 pb-4 text-black-50 h5">
      Parece que has intentado abrir una página que no existe. Pudo haberse
      {' '}
      <b className="text-farmex-purple">eliminado, movido o no está disponible en este momento.</b>
    </p>
    <Link to="/">
      Regresar a Inicio
    </Link>
  </div>
);

export default PageNotFound;
